<template>
  <span class="section-links">
    <a v-for="item, i of items" :key="i" 
      :title="$t(item.title)"
      :href="item.href" v-smooth-scroll>
      <svg-icon :name="item.icon"/>
    </a>
  </span>
</template>

<script>
  export default {
    props: ['items']
  }
</script>



// WEBPACK FOOTER //
// src/components/MenuItems.vue